import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import StatisticsByUTMCSV from './StatisticsByUTMCSV';
import {
    getData,
    getHeaderName
} from './StatisticsByUTMCSV.selectors';

const mapStateToPropsSelectors = createStructuredSelector({
    data: getData,
    headerName: getHeaderName
});

const StatisticsByUTMCSVComponent = connect(
    function mapStateToProps(state) {
        return {
            ...mapStateToPropsSelectors(state)
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
        };
    }
)(StatisticsByUTMCSV);

export default StatisticsByUTMCSVComponent;
